import React from "react";
import PropTypes from "prop-types";
import { CalendarDays } from "lucide-react";
import { formatDisplayDate } from "../utils/formatDisplayDate";

// Head of the premiere list: the "Browse premieres" tool is the list itself,
// so its header band carries the count, freshness, and filter hint instead of
// a hero tile that scrolls here.
const BrowsePremieresBand = ({ premiereCount = 0, updatedAt = "" }) => {
    const updatedLabel = formatDisplayDate(updatedAt);
    const countLabel = premiereCount > 0
        ? `${premiereCount} new and returning scripted shows in the next 30 days`
        : "New and returning scripted shows in the next 30 days";
    return (
        <header className="browse-band" id="browse-premieres">
            <span className="browse-band__icon" aria-hidden="true"><CalendarDays className="h-5 w-5" /></span>
            <div className="browse-band__titles">
                <h2 className="browse-band__title">Upcoming premieres</h2>
                <p className="browse-band__status">
                    {countLabel}
                    {updatedLabel && <span className="browse-band__updated"> · Updated {updatedLabel}</span>}
                </p>
            </div>
        </header>
    );
};

BrowsePremieresBand.propTypes = {
    premiereCount: PropTypes.number,
    updatedAt: PropTypes.string,
};

export default BrowsePremieresBand;
